import { getTimeConditions } from './time-condition-format'
const combineTravelDetails = (trip: any, $formatters: any) => {
  const result: any[] = []
  const { journeys, travelDetails } = trip
  let start: number = 0
  if (Array.isArray(journeys)) {
    let lastStageIndex = -1
    journeys.forEach((j: any, ji: number) => {
      const lastJ = ji === journeys.length - 1
      const { travelIndexStart, travelIndexEnd } = j
      if (start < travelIndexStart) {
        // Not use codes
        for (let i = start; i < travelIndexStart; i++) {
          const tmpTask = travelDetails[i]
          if (tmpTask.type === 'task') {
            tmpTask.timingStartArr = getTimeConditions($formatters, tmpTask, 'start')
            tmpTask.timingEndArr = getTimeConditions($formatters, tmpTask, 'end')
          }

          Object.assign(tmpTask, {
            travelIndex: i,
            ignoreTime: true,
            ata: $formatters.datetime(tmpTask.ata, 'YYYY-MM-DD HH:mm'),
            atd: $formatters.datetime(tmpTask.atd, 'YYYY-MM-DD HH:mm')
          })
          result.push(tmpTask)
        }
      }
      let tmpFirstStageIndex = -1
      let tmpLastStageIndex = -1
      for (let i = travelIndexStart; i <= travelIndexEnd; i++) {
        const tmpTravel = j.travelDetails[i]
        if (tmpTravel.type === 'stage') {
          if (i > tmpLastStageIndex) {
            tmpLastStageIndex = i
          }
          if (tmpFirstStageIndex < 0) {
            tmpFirstStageIndex = i
          }
        }
        if (tmpTravel.type === 'task') {
          tmpTravel.timingStartArr = getTimeConditions($formatters, tmpTravel, 'start')
          tmpTravel.timingEndArr = getTimeConditions($formatters, tmpTravel, 'end')
        }

        result.push(tmpTravel)
      }
      if (lastStageIndex >= 0 && tmpFirstStageIndex >= 0) {
        const tmpTravel = j.travelDetails[tmpFirstStageIndex]
        result[lastStageIndex].etd = tmpTravel?.etd || 0
        result[lastStageIndex].atd = tmpTravel?.atd || 0
        result[lastStageIndex].atdEstimate = tmpTravel?.atdEstimate || 0
      }
      if (!lastJ && tmpLastStageIndex) {
        lastStageIndex = tmpLastStageIndex
        result[lastStageIndex].etd = 0
        result[lastStageIndex].atd = 0
        result[lastStageIndex].atdEstimate = 0
      }
      start = travelIndexEnd + 1
    })
  }
  return result
}
export { combineTravelDetails }
